import { render, staticRenderFns } from "./ModalEditFees.vue?vue&type=template&id=1279756c&"
import script from "./ModalEditFees.vue?vue&type=script&lang=js&"
export * from "./ModalEditFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports